import React from 'react';
import { Toolbar, SaveButton } from 'react-admin';

export default props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);